export default __webpack_public_path__ + "static/media/close.92e3ec02.svg";